import { render, staticRenderFns } from "./ProTempIdMsg.vue?vue&type=template&id=8213b1ca&"
import script from "./ProTempIdMsg.vue?vue&type=script&lang=js&"
export * from "./ProTempIdMsg.vue?vue&type=script&lang=js&"
import style0 from "./ProTempIdMsg.vue?vue&type=style&index=0&id=8213b1ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports